<template>
  <fixed-header :fixed.sync="isFixed" :threshold="300" :scroll="handleScroll" >
    <div :class="{ 'is-fixed': isFixed }">
      <b-navbar toggleable="lg"  fixed="top" variant="info" :class=" classNavTop"> <!-- variant="faded" type="dark" variant="info"-->
        <b-navbar-brand href="/">
          <img src="@/assets/imagens/logo_brasao.png" width="200px" alt="" class="">
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items-->
          <b-navbar-nav class="navbar-nav ml-auto">
            <b-nav-item class="nav-item mx-1" href="#boletins">Boletins</b-nav-item>
            <b-nav-item class="nav-item mx-1 text-nowrap" href="#notas-orientativas">Notas Orientativas</b-nav-item>
            <b-nav-item class="nav-item mx-1" href="#coe">COE</b-nav-item>
            <b-nav-item class="nav-item mx-1" href="#noticias">Notícias</b-nav-item>
            <b-nav-item class="nav-item mx-1" href="#videos">Vídeos</b-nav-item>
            <b-nav-item class="nav-item mx-1" href="#prevencao">Prevenção</b-nav-item>

            <a class="btn navbar-btn mx-2 text-white btn-outline-light" href="#transparencia">Transparência</a>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </fixed-header>
</template>

<script>
// https://forum.vuejs.org/t/fixed-navbar-on-scroll-using-vuejs-bootstrap-4/93239
// https://github.com/TriDiamond/vuejs-scroll-fixed-header
// https://github.com/potato4d/vue-fixed-header#readme
import FixedHeader from 'vue-fixed-header'

export default {
  name: "Bloco1Navbar",
  components: {
    FixedHeader
  },
  data() {
    return {
      isFixed: true,
      classNavTop: 'bg-primary-local navbar-dark'
    };
  },
  methods: {
    handleScroll: function() {
      this.classNavTop = window.scrollY > 25 ? 'bg-secondary-local navbar-dark' : 'bg-primary-local navbar-dark'
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
.fixed-header {
  z-index: 1;
}
/*.navbar-ontop {
   background-color: transparent !important;
}*/
/* #dc3545 #bd2130 - são as cores vermelhas */
.bg-primary-local {
  background-color: #0e8c82 !important; }

a.bg-primary-local:hover, a.bg-primary-local:focus,
button.bg-primary-local:hover,
button.bg-primary-local:focus {
  background-color: #12bbad !important; }

.bg-secondary-local {
  background-color: #12bbad !important; }

a.bg-secondary-local:hover, a.bg-secondary-local:focus,
button.bg-secondary-local:hover,
button.bg-secondary-local:focus {
  background-color: #0e8c82 !important; }
</style>